import React, { useEffect, useState } from 'react';
import FormEditor from '../../atoms/jsonFormEditor/FormEditor';
import './style.css'
import { useDispatch, useSelector } from 'react-redux';
import { handleSnackBar, invokePostService, setDashboardRefresh, setReRender } from '../../../store/global/actions';
import { getViews } from '../../../store/views/selectors';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { editView } from '../../../store/views/actions';
import { updateViewSchema } from '../../../utils/DashboardBuilder';


// Options for the form
const options = {
    form_name_root: 'gaugeRange',
    show_errors: 'never',
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
    disable_array_reorder: true,
    disable_array_add: true,
};

// Schema of the form (structure)
let schema = {
    type: 'object',
    properties: {
        range: {
            type: 'array',
            format: 'table',
            items: {
                type: 'object',
                properties: {
                    low: {
                        title: 'Low',
                        type: 'number',
                    },
                    high: {
                        title: 'High',
                        type: 'number',
                    },
                    color: {
                        title: 'Color',
                        type: 'string',
                        format: 'color'
                    },
                },
            },
        }
    }
};

export default function GaugeRangeSelector({ selectedWidget, onCompletion, onClose }) {
    // --------------------------- Hooks -------------------------------------------------
    const dispatch = useDispatch();

    // --------------------------- States ------------------------------------------------
    const [schemaValues, setSchemaValues] = useState({
        range: null
    })
    const [keySchema, setKeySchema] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [key, setKey] = useState(1);
    const [loading, setLoading] = useState(false);

    // --------------------------- Selectors ---------------------------------------------
    const selectedView = useSelector(getViews);

    // Function for the validation of the schema
    const validation = (schema, value, path) => {
        var errors = [];

        return errors;
    };

    /**
     * Function for add a new row of fields into the form. 
     * This function checks whether the last row is filled or not
     */
    const onAddRow = () => {
        const currentRows = schemaValues.range;
        const lastRow = currentRows[currentRows.length - 1];

        setSchemaValues({
            range: [
                ...currentRows,
                {
                    high: 0,
                    low: 0,
                    color: '#ffffff'
                }
            ]
        })
        setKeySchema(prev => prev + 1);

    }

    /**
     * This is an event listner function which will trigger when any changes happen to the form
     * 
     * @param data contains the changed value of the form 
     */
    const onChangeJsonEditor = (data) => {
        setSchemaValues({
            range: data.range
        })
        const rangeHeadings = document.querySelectorAll('#gauge_editor .card-title');
        rangeHeadings.forEach((heading) => heading.style.display = 'none')
    }

    /**
     * This is an event listner function which will trigger when any changes happen to the form
     * 
     * @param data.ranges contains the values of the form
     */
    const onFormUpdation = (data) => {
        setIsUpdating(true)
        selectedWidget?.children?.map((child) => {
            if (child.name === 'ranges') {
                child.default = data.range;
            }
        });
        dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: {...selectedWidget, id: selectedWidget.id} }));
        let updatedView = updateViewSchema(selectedView, 'edit', { id: selectedWidget.id, updatedData: selectedWidget });
        dispatch(invokePostService('updateView', { view: updatedView }, [updatedView._id])).then((response) => {
            const { status } = response;
            setIsUpdating(false);
            if (status) {
                dispatch(editView(updatedView))
                onCompletion('Widget', 'edit')
            } else {
                dispatch(handleSnackBar({ open: true, message: 'Something went wrong! Try again', severity: 'error' }))
            }
            if (selectedWidget?.viewCopy === true) {
                dispatch(setReRender());
            }
        })
    }


    useEffect(() => {
        if (selectedWidget) {
            setLoading(true)
            let defaultValues = null;
            selectedWidget.children.forEach((child) => {
                if (child.name === 'ranges') {
                    defaultValues = child.default;
                }
            })

            setKey(prev => prev + 1)

            if (defaultValues?.length > 0) {
                setSchemaValues({
                    range: defaultValues
                });
                setKeySchema(prev => prev + 1)
            }
        }
        setLoading(false)
    }, [])



    return (
        <>
            {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '35vh' }} />}
            {
                !loading &&
                <FormEditor schema={schema} options={options} key={key} isUpdating={isUpdating} validation={validation} keySchema={keySchema} schemaValues={schemaValues} onClose={onClose} onChangeJsonEditor={onChangeJsonEditor} editorId="gauge_editor" onAddRow={onAddRow} onSave={onFormUpdation} action='edit' isAddRow='Add range' />
            }
        </>
    );
}
